import React, { Fragment } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'

import Dashboard from '@wrappers/Dashboard'
import { Title } from '@lib'
import QuestionnaireForm from '@shared/QuestionnaireForm'

const Content = ({ user }) => {
  const { id } = useParams()
  const navigate = useNavigate()

  const handleSave = () => {
    Swal.fire({
      text: 'Questionnaire setup updated!',
      icon: 'success',
      showConfirmButton: false,
      timer: 3000
    })

    navigate('/settings/questionnaire-admin')
  }

  return (
    <Fragment>

      <Title text='Edit Questionnaire Setup' user={user}/>

      <QuestionnaireForm
        id={id}
        onSave={handleSave}
        user={user}
      />
    </Fragment>
  )
}

Content.propTypes = {
  user: PropTypes.object
}
const EditQuestionnaireSetup = () => {
  return (
    <Dashboard>
      <Content />
    </Dashboard>
  )
}

export default EditQuestionnaireSetup
